import React from 'react';
import PropTypes from 'prop-types';

import './SectionTabHeader.scss';
import SectionTabMobileDropdown from './SectionTabMobileDropdown/SectionTabMobileDropdown';

export const commonMenuItemShape = {
    //Text
    name: PropTypes.string.isRequired,
    //If a Link This is Required
    url: PropTypes.string,
    //Number for counter
    counter: PropTypes.number,
    //If a Button This is Required
    onClick: PropTypes.func,
};
export const desktopMenuItem = {
    ...commonMenuItemShape,
    //For Dropwdown Items If Exists
    dropdownItems: PropTypes.arrayOf(PropTypes.shape(commonMenuItemShape)),
};

export default class SectionTabHeader extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            activeItemName: this.getActiveTitle(),
        };
    }

    static propTypes = {
        pagePath: PropTypes.string.isRequired,
        desktopMenuItems: PropTypes.arrayOf(PropTypes.shape(desktopMenuItem))
            .isRequired,
        mobileMenuItems: PropTypes.arrayOf(PropTypes.shape(commonMenuItemShape))
            .isRequired,
        defaultActive: PropTypes.string,
    };

    static defaultProps = {
        pagePath: '',
        desktopMenuItems: [],
        mobileMenuItems: [],
    };

    //Menu Item: Checks if item.dropdownItems => subnavdropdown, if href => link, otherwise button
    renderMenu = (items) => items && items.map(this.renderMenuItem);

    renderMenuItem = (item, i) => {
        let component;
        let buttonPaddingStyle = '';
        const classes = `menu-item contentCardLabel ${
            item.name === this.state.activeItemName ? 'active' : ''
        } ${buttonPaddingStyle}`;
        switch (true) {
            case item.dropdownItems && item.dropdownItems.length > 0:
                component = (
                    <SectionTabMobileDropdown
                        dropdownItems={item.dropdownItems}
                        renderMenuItem={this.renderMenuItem}
                        dropdownTitle={item.name}
                    />
                );
                break;
            case item.url && item.url.length > 0:
                component = (
                    <a
                        href={item.url}
                        href={item.url}
                        target={
                            this.props.shouldSubNavOpenNewTabs
                                ? '_blank'
                                : '_self'
                        }
                    >
                        {item.name + this.getCounterText(item)}
                    </a>
                );
                break;
            case item.onClick !== undefined:
                component = (
                    <button onClick={item.onClick}>
                        {`${item.name}${this.getCounterText(
                            item
                        )}`.toUpperCase()}
                    </button>
                );
                buttonPaddingStyle = 'button-menu-item-styling';
                break;
            default:
                component = (
                    <a href={item.url}>
                        {item.name + this.getCounterText(item)}
                    </a>
                );
        }
        return (
            <li className={`${classes} ${buttonPaddingStyle}`} key={item.name}>
                {component}
            </li>
        );
    };

    getCounterText = (item) => (item.counter ? ` (${item.counter})` : '');

    getActiveTitle = () => {
        const path = this.props.pagePath.toLowerCase();
        const activeItems = this.props.mobileMenuItems.filter((item) => {
            if (path.startsWith('/jobs/')) {
                return item.name === 'Jobs';
            }
            return item.url === path;
        });

        switch (true) {
            case activeItems.length > 0:
                return activeItems[0].name;
            case this.props.defaultActive &&
                this.props.defaultActive.length > 0:
                return this.props.defaultActive;
            default:
                return null;
        }
    };

    render() {
        return (
            <div
                className={`component-Elements-SectionTabHeader ${this.props.className}`}
            >
                <ul className="menu menu-row desktop-display">
                    {this.renderMenu(this.props.desktopMenuItems)}
                </ul>
                <div className="menu menu-row mobile-display">
                    <SectionTabMobileDropdown
                        dropdownItems={this.props.mobileMenuItems}
                        renderMenuItem={this.renderMenuItem}
                        dropdownTitle={this.state.activeItemName}
                    />
                </div>
            </div>
        );
    }
}
